/* prettier-ignore */

import { Component, computed, HostListener, inject, signal, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { RestService } from 'src/app/services/rest.service';
import { ToolsService } from '../../services/tools.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { NewCustomRouteService } from 'src/app/pages/new-custom-route/new-custom-route.service';
import { CookieService } from 'ngx-cookie-service';
import { AuthService } from '../../services/auth.service';
import { UserService } from 'src/app/services/user.service';
import { BreakpointsService } from 'src/app/services/breakpoints.service';
import Swal from "sweetalert2";
import { PassportService } from 'src/app/components/passport/service/passport.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    encapsulation: ViewEncapsulation.None,
})

export class HeaderComponent {
    private cookieService = inject(CookieService)
    private routeService = inject(NewCustomRouteService);
    public breakpointsService = inject(BreakpointsService);
    private passportService = inject(PassportService);
    
    public disableTouch = computed(() => this.routeService.disableTouch());
    public isInfoRoutePage = computed(() => this.tools.isInfoRoutePage());
    public languages = computed( () => this.tools.languages());
    public isWebApp = computed(() => this.tools.isWebApp());
    public passportEnabled = computed(() => this.passportService.passportsEnabled());

    public logo: any;
    public currentClientId: any;

    @HostListener('document:click', ['$event'])
    hideModalOnClick(event: MouseEvent) {
        if (!this.tools.menuIsShown) return;
        this.tools.menuIsShown = false;
    }
  
    constructor(
        private router: Router, 
        public translate: TranslateService, 
        public rest: RestService, 
        public tools: ToolsService, 
        private userService: UserService,
        private authService: AuthService,
        public navigation: NavigationService
    ) {
        this.logo = this.rest?.device?.logo?.value;
        this.currentClientId = this.rest?.device?.client;
    }

    goToHome(){
        if (this.tools.isTechEditMode() || this.tools.isRegisterMode() || this.isInfoRoutePage()) return;
        this.router.navigateByUrl('/home');
    }

    goBack(){
        const currentUrl = this.router.url;
        if (currentUrl.includes('custom-route')){
              Swal.fire({
                  title: this.translate.instant(`¿Deseas abandonar la página de ruta?`),
                  showDenyButton: false,
                  showCancelButton: true,
                  confirmButtonColor: "#ff0000",
                  cancelButtonColor: "#000000",
                  confirmButtonText: this.translate.instant("Salir"),
                  cancelButtonText: this.translate.instant(`Cancelar`),
                  reverseButtons: true,
                  scrollbarPadding: false
                }).then((result) => {
                    if (result.isConfirmed)
                        this.navigation.goBack();
                })
            return;
        }

        if(this.isBackDistributor()){
            this.goDistributor();
            return;
        }

        if (currentUrl.includes('not-found'))
            this.navigation.resetNavigation();
    
        this.navigation.goBack();
    }

    goDistributor(){
        if (this.tools.isPreProduction()){
            const splitUrl = this.tools.homeDistributor?.split('.');
            const splitHttp = splitUrl?.[0].split('//');
            const nameIndex = splitHttp?.[splitHttp?.length - 1]?.trim();
            this.cookieService.set('preProduction', nameIndex)
            window.location.assign(`${window.location.origin}`)
            return;
        }
        window.location.assign(this.tools.homeDistributor);
    }

    showBackButton(){
        return !this.router.url.includes('/home') && !this.tools.isTechEditMode()
    }

    isBackDistributor(){
        return this.tools.homeDistributor && this.router.url.includes('/home')
    }

    handlePassportClick(){
        if (!this.authService.isLoggedIn()){
            this.userService.login();
            return;
        }

        this.router.navigateByUrl('/my-account/passports')
    }

}